import Avatar from "components/BaseWidgets/Avatar";
import "./style.scss";
import profilePic from "assets/images/png/dummy_avatar.png";
import { FavouriteFill } from "assets/icons";
import { getUser } from "utils/storage";
import { useChatPreference } from "hooks/api/useChatPreference";

function ChatList({ data, isActive, onSelectChat }) {
  const userId = getUser().aec_id;

  const sorted = [userId, data?.aec_id].sort();
  const generatedChatId = `${sorted[0]}_${sorted[1]}`;
  return (
    <div
      className={`chatlist-card ${isActive ? "active" : ""}`}
      onClick={() => onSelectChat?.(generatedChatId, data)}
    >
      <div className="flex items-center gap-3 overflow-hidden avatar">
        <Avatar
          url={
            data?.profile_image && typeof data?.profile_image === "string"
              ? data?.profile_image
              : profilePic
          }
          size={48}
        />
        <div className="flex flex-col gap-1">
          <span className="font-body-md leading-3 name">{data?.username}</span>
          <p className={`description font-body-normal`}>
            {data?.last_message || ""}
          </p>
        </div>
      </div>
      <div className="flex flex-col items-end gap-2 justify-between">
        <span className="font-body-normal leading-1">
          {data?.last_message_time_converted}
        </span>
        <div className="flex items-center gap-2">
          {/* TODO: Need implement favorite */}
          {data?.favorite && (
            <div className="icon-wrapper">
              <FavouriteFill />{" "}
            </div>
          )}
          {data?.pinned && (
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.625 15L5.9025 11.7225"
                stroke="#323232"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.71603 8.47051C3.42278 8.76376 3.42278 9.23851 3.71603 9.53101L5.90453 11.7195L8.09303 13.908C8.38628 14.2013 8.86103 14.2013 9.15353 13.908L10.0348 13.0268C10.1758 12.8858 10.2545 12.6953 10.2545 12.4965V9.54451L12.4295 7.36951L14.1613 7.46176C14.3735 7.47301 14.5813 7.39351 14.7313 7.24351L15.1618 6.81301C15.455 6.51976 15.455 6.04501 15.1618 5.75251L11.8723 2.46301C11.579 2.16976 11.1043 2.16976 10.8118 2.46301L10.3813 2.89351C10.2305 3.04426 10.151 3.25126 10.163 3.46351L10.2553 5.19526L8.08028 7.37026H5.12753C4.92878 7.37026 4.73753 7.44901 4.59728 7.59001L3.71603 8.47051V8.47051Z"
                stroke="#323232"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.427 7.37251L10.252 5.19751"
                stroke="#323232"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          )}

          {/* <FavouriteFill /> */}
          <p>
            {data.muted && (
              <div className="icon-wrapper">
                <svg
                  width="17"
                  height="20"
                  viewBox="0 0 17 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.75 8.75C9.541 8.75 7.75 6.959 7.75 4.75C7.75 2.586 9.59 0.748002 11.753 0.750002C13.961 0.752002 15.75 2.542 15.75 4.75C15.75 6.959 13.96 8.75 11.75 8.75"
                    stroke="#4D4C4D"
                    stroke-width="1.5"
                  />
                  <path
                    d="M9.35039 18.75H6.15039"
                    stroke="#4D4C4D"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.883 3.75H7.75V3.75C4.989 3.75 2.75 5.989 2.75 8.75V8.75V8.782V11.254C2.75 11.578 2.567 11.873 2.278 12.018L1.775 12.269C1.147 12.584 0.75 13.226 0.75 13.928V13.928C0.75 14.952 1.58 15.782 2.604 15.782H12.896C13.92 15.782 14.75 14.952 14.75 13.928V13.928C14.75 13.226 14.353 12.584 13.725 12.27L13.222 12.019C12.933 11.873 12.75 11.578 12.75 11.254V8.621"
                    stroke="#4D4C4D"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.8801 5.88012L10.6201 3.62012"
                    stroke="#4D4C4D"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.8801 3.62012L10.6201 5.88012"
                    stroke="#4D4C4D"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            )}
          </p>

          {data?.unread_count > 0 && (
            <>
              {" "}
              <div className="unread-count">{data?.unread_count}</div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ChatList;
